import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class Tab extends UcoastEl {
  static htmlSelector = 'custom-tab'

  buttons: NodeListOf<HTMLElement>
  contents: NodeListOf<HTMLElement>


  constructor() {
    super()
    this.buttons = q.rl('[data-uc-tab-button]', this)
    this.contents = q.rl("[data-uc-tab-content-id]", this)
    this.buttons.forEach((button, buttonIndex) =>
      button.addEventListener('click', (event: Event) => {
        this.onTabClick(event,  buttonIndex)
      })
    )
  }

  onTabClick(event: Event, buttonIndex: number) {
    event.preventDefault();
    const target = event.target as HTMLElement;
    const targetId = this.getTargetId(target) as string;

    this.toggleButtonActiveClass(buttonIndex)
    this.toggleContent(targetId);

  }

  getTargetId(target: HTMLElement) {
    const isValidAnchorTag = target.tagName == "A" ? target : target.querySelector('a');
    if( !isValidAnchorTag) return;
    return isValidAnchorTag.getAttribute('href')?.substring(1);
  }

  toggleContent(targetId: string){
    this.contents.forEach(contentElement => {
      const contentId = contentElement.getAttribute(`data-uc-tab-content-id`);
      if(contentId != targetId) {
        contentElement.classList.add('hidden')
      }else {
        contentElement.classList.remove("hidden")
      }
    })
  }

  toggleButtonActiveClass(clickedButtonIndex: number) {
    this.buttons.forEach((button:HTMLElement, buttonIndex: number) => {
      if( buttonIndex === clickedButtonIndex ) {
        button.classList.add("active")
      }else {
        button.classList.remove("active")
      }
    })
  }
}
